const locales = {
    en: "English",
    de: "Deutsch"
}

const fallback = "en";

export { locales, fallback };